import React, { useEffect } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { Field, Formik } from "formik";
import { TextField } from "formik-material-ui";
import MaterialTable from "material-table";

import { blue, red } from "@material-ui/core/colors";
import Swal from "sweetalert2";
import _ from "lodash";
import Moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { hasRole, isAllowed } from "src/utils/Auth";
import { getBudgetAdjTo } from "src/redux/actions/budgetAdjustment.action";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  panelRoot: {
    "& .MuiButton-root": {
      margin: theme.spacing(1),
    },
    palette: {
      secondary: {
        main: red[500],
      },
    },
  },
}));

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      fixedDecimalScale
      decimalScale={2}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function BudgetRequisitionFormComponent({
  formType,
  formValue,
  onSubmit,
  departmentTo,
  projectsTo,
  budgetsTo,
  ReasonLog,
}) {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const {
    result: { perid, fullname, currency_code },
  } = useSelector((state) => state.loginReducer);
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={formValue}
      onSubmit={(values, { setSubmitting }) => {
        onSubmit(values);
        setSubmitting(false);
      }}
      validate={(values) => {
        const errors = {};

        if (!values.BUDGET_YEAR) {
          errors.BUDGET_YEAR = "Budget year can't be blank";
        }

        if (!values.REASON_ADJUSTMENT) {
          errors.REASON_ADJUSTMENT = "Reason Adjustment can't be blank";
        }

        if (values.BUDGET_TYPE === 1 && values.ADJ_TYPE === 1) {
          if (!values.T_PROJECT_CODE) {
            errors.T_PROJECT_CODE = "Project code can not be blank";
          }
          if (!values.T_BUDGET_CODE) {
            errors.T_BUDGET_CODE = "Budget code can not be blank";
          }
        }

        if (values.BUDGET_TYPE === 0 && values.ADJ_TYPE === 1) {
          if (!values.T_BUDGET_CODE) {
            errors.T_BUDGET_CODE = "Budget code can not be blank";
          }
        }

        if (values.AMOUNT && values.ADJ_TYPE !== 2 && values.ADJ_TYPE !== 4) {
          if (values.AMOUNT > parseFloat(values.F_BUDGET_REMAIN)) {
            errors.AMOUNT = "Amount must be not greater than the budget remain";
          }
        }

        if (!values.AMOUNT) {
          errors.AMOUNT = "Amount can not be blank";
        }

        if (values.AMOUNT <= 0) {
          errors.AMOUNT = "Amount must be greater than 0";
        }

        return errors;
      }}
      render={({
        submitForm,
        resetForm,
        isSubmitting,
        setSubmitting,
        touched,
        errors,
        values,
        setFieldValue,
      }) => (
        <Grid container spacing={3}>
          <Grid item lg={6} md={6} xs={12}>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12}>
                <Card>
                  <CardHeader
                    title={
                      formType === "CREATE"
                        ? "Budget Information"
                        : `Adjustment No. ${values.DOCUMENT_NO}`
                    }
                  />
                  <Divider />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="BUDGET_YEAR"
                          label="Budget Year"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={Boolean(
                            touched.BUDGET_YEAR && errors.BUDGET_YEAR
                          )}
                          disabled
                          helperText={touched.BUDGET_YEAR && errors.BUDGET_YEAR}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="STATUS_DESC"
                          label="Status"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="BUDGET_TYPE_DESC"
                          label="Budget Type"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="ADJ_TYPE"
                          label="Adjustment Type"
                          select
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled={Boolean(values.STATUS !== 0)}
                          onChange={(e) => {
                            setFieldValue("AMOUNT", "");
                            setFieldValue("ADJ_TYPE", e.target.value);
                            setFieldValue("T_PROJECT_CODE", "");
                            setFieldValue("T_PROJECT_NAME", "");
                            setFieldValue("T_BUDGET_CODE", "");
                            setFieldValue("T_BUDGET_NAME", "");
                            setFieldValue("T_BUDGET_REMAIN", "");

                            if (e.target.value === 1) {
                              setFieldValue("T_BRAND", values.F_BRAND);
                              setFieldValue(
                                "T_DEPARTMENT",
                                values.F_DEPARTMENT
                              );
                            } else {
                              setFieldValue("T_BRAND", "");
                              setFieldValue("T_DEPARTMENT", "");
                            }
                          }}
                        >
                          <MenuItem value={1}>TRANSFER</MenuItem>
                          <MenuItem value={2}>INCREASE</MenuItem>
                          <MenuItem value={3}>DECREASE</MenuItem>
                          <MenuItem value={4}>RETURN</MenuItem>
                        </Field>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} xs={12}>
                <Card>
                  <CardHeader title="Transfer From" />
                  <Divider />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="F_PROJECT_CODE"
                          label="Project Code"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="F_PROJECT_NAME"
                          label="Project Name"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="F_BUDGET_CODE"
                          label="Budget Code"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="F_BUDGET_NAME"
                          label="Budget Name"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="F_DEPARTMENT_NAME"
                          label="Department"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      {hasRole(authorizePR.data, [
                        "super-admin",
                        "manager-budget-adjustment",
                        "verifier-budget-adjustment",
                      ]) && (
                        <Grid item md={12} xs={12}>
                          <Field
                            component={TextField}
                            name="F_BUDGET_REMAIN"
                            label={`Budget Remain (${currency_code})`}
                            fullWidth
                            value={parseFloat(values.F_BUDGET_REMAIN).toFixed(
                              2
                            )}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            InputProps={{
                              inputComponent: NumberFormatCustom,
                            }}
                            variant="outlined"
                            disabled
                          />
                        </Grid>
                      )}

                      <Grid item md={12} xs={12}>
                        <Divider />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="AMOUNT"
                          label={`Amount (${currency_code})`}
                          fullWidth
                          variant="outlined"
                          error={Boolean(touched.AMOUNT && errors.AMOUNT)}
                          helperText={touched.AMOUNT && errors.AMOUNT}
                          onKeyUp={(e) => {
                            setFieldValue(
                              "AMOUNT",
                              parseFloat(
                                e.target.value.replace(/[$,]+/g, "")
                              ).toFixed(2)
                            );
                          }}
                          disabled={Boolean(values.STATUS !== 0)}
                          onBlur={(e) => {
                            let value = parseFloat(
                              e.target.value.replace(/[$,]+/g, "")
                            ).toFixed(2);

                            switch (values.ADJ_TYPE) {
                              case 1:
                                setFieldValue(
                                  "T_BUDGET_REMAIN",
                                  parseFloat(values.F_BUDGET_REMAIN) -
                                    parseFloat(value)
                                );

                                break;
                              case 2:
                                setFieldValue(
                                  "T_BUDGET_REMAIN",
                                  parseFloat(values.F_BUDGET_REMAIN) +
                                    parseFloat(value)
                                );
                                break;
                              case 3:
                                setFieldValue(
                                  "T_BUDGET_REMAIN",
                                  parseFloat(values.F_BUDGET_REMAIN) -
                                    parseFloat(value)
                                );
                                break;
                              case 4:
                                setFieldValue(
                                  "T_BUDGET_REMAIN",
                                  parseFloat(values.F_BUDGET_REMAIN) +
                                    parseFloat(value)
                                );
                                break;
                              default:
                                setFieldValue("T_BUDGET_REMAIN", 0);
                            }
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          InputProps={{
                            inputComponent: NumberFormatCustom,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={6} xs={12}>
                <Card>
                  <CardHeader title="Transfer To" />
                  <Divider />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="T_PROJECT_CODE"
                          label="Project Code"
                          select
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={Boolean(
                            touched.T_PROJECT_CODE && errors.T_PROJECT_CODE
                          )}
                          helperText={
                            touched.T_PROJECT_CODE && errors.T_PROJECT_CODE
                          }
                          variant="outlined"
                          disabled={Boolean(
                            values.BUDGET_TYPE === 0 ||
                              values.ADJ_TYPE !== 1 ||
                              values.STATUS >= 1
                          )}
                          onChange={(e) => {
                            if (e.target.value) {
                              const {
                                BUDGETP_CODE,
                                BUDGETP_NAME,
                                DEPARTMENT_ID,
                              } = _.find(projectsTo, {
                                BUDGETP_CODE: e.target.value,
                              });

                              setFieldValue("T_PROJECT_NAME", BUDGETP_NAME);
                              setFieldValue("T_PROJECT_CODE", BUDGETP_CODE);
                              setFieldValue("T_DEPARTMENT", DEPARTMENT_ID);

                              dispatch(
                                getBudgetAdjTo(
                                  values.F_BUDGET_CODE,
                                  BUDGETP_CODE === values.F_PROJECT_CODE
                                    ? 0
                                    : BUDGETP_CODE
                                )
                              );
                            }
                          }}
                        >
                          {projectsTo &&
                            projectsTo.map((item) => (
                              <MenuItem
                                MenuItem={item.BUDGETP_CODE}
                                value={item.BUDGETP_CODE}
                              >
                                {`${item.BUDGETP_CODE} (${item.DEPARTMENT_NAME})`}
                              </MenuItem>
                            ))}
                        </Field>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="T_PROJECT_NAME"
                          label="Project Name"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="T_BUDGET_CODE"
                          label="Budget Code"
                          select
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={Boolean(
                            touched.T_BUDGET_CODE && errors.T_BUDGET_CODE
                          )}
                          helperText={
                            touched.T_BUDGET_CODE && errors.T_BUDGET_CODE
                          }
                          variant="outlined"
                          disabled={Boolean(
                            values.ADJ_TYPE !== 1 || values.STATUS >= 1
                          )}
                          onChange={(e) => {
                            if (e.target.value) {
                              const { ACC_NAME } = _.find(budgetsTo, {
                                ACC_CODE: e.target.value,
                              });
                              setFieldValue("T_BUDGET_NAME", ACC_NAME);
                              setFieldValue("T_BUDGET_CODE", e.target.value);
                            }
                          }}
                        >
                          {budgetsTo &&
                            budgetsTo.map((item) => (
                              <MenuItem
                                MenuItem={item.ACC_CODE}
                                value={item.ACC_CODE}
                              >
                                {item.ACC_CODE}
                              </MenuItem>
                            ))}
                        </Field>
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="T_BUDGET_NAME"
                          label="Budget Name"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="T_DEPARTMENT"
                          label="Department"
                          select
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          error={Boolean(
                            touched.T_DEPARTMENT && errors.T_DEPARTMENT
                          )}
                          helperText={
                            touched.T_DEPARTMENT && errors.T_DEPARTMENT
                          }
                          variant="outlined"
                          disabled={Boolean(
                            values.F_BRAND === 221 ||
                              values.ADJ_TYPE !== 1 ||
                              values.STATUS >= 1 ||
                              values.BUDGET_TYPE === 1
                          )}
                        >
                          {departmentTo.map((item) => (
                            <MenuItem
                              MenuItem={item.ORG_DEPARTMENT_ID}
                              value={item.ORG_DEPARTMENT_ID}
                            >
                              {item.department}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      {hasRole(authorizePR.data, [
                        "super-admin",
                        "manager-budget-adjustment",
                        "verifier-budget-adjustment",
                      ]) && (
                        <>
                          <Grid item md={12} xs={12}>
                            <Divider />
                          </Grid>
                          <Grid item md={12} xs={12}>
                            <Field
                              component={TextField}
                              name="T_BUDGET_REMAIN"
                              label={`Budget Remain After Adjustment (${currency_code})`}
                              fullWidth
                              value={
                                values.T_BUDGET_REMAIN &&
                                parseFloat(values.T_BUDGET_REMAIN).toFixed(2)
                              }
                              InputLabelProps={{
                                shrink: true,
                              }}
                              InputProps={{
                                readOnly: true,
                                inputComponent: NumberFormatCustom,
                              }}
                              variant="outlined"
                              disabled
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12} xs={12}>
                <Card>
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={12} xs={12}>
                        <Field
                          component={TextField}
                          name="REASON_ADJUSTMENT"
                          label="Reason for Budget Adjustment Request"
                          multiline
                          fullWidth
                          disabled={Boolean(values.STATUS !== 0)}
                          rows={4}
                          error={Boolean(
                            touched.REASON_ADJUSTMENT &&
                              errors.REASON_ADJUSTMENT
                          )}
                          helperText={
                            touched.REASON_ADJUSTMENT &&
                            errors.REASON_ADJUSTMENT
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={6} xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={12} md={12} xs={12}>
                <Card>
                  <CardHeader title="User Profile" />
                  <Divider />
                  <CardContent>
                    <Grid container spacing={3}>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="REQUESTED_BY_NAME"
                          label="Requester Name"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="REQUESTED_BRAND_NAME"
                          label="Brand"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item md={6} xs={12}>
                        <Field
                          component={TextField}
                          name="REQUESTED_DEPARTMENT_NAME"
                          label="Department"
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item lg={12} md={12} xs={12}>
                <MaterialTable
                  title="Reason"
                  columns={[
                    {
                      title: "Status",
                      field: "STATUS",
                      lookup: {
                        1: "Prepared",
                        2: "Re-Prepare",
                        3: "Reviewed",
                        4: "Reviewer Rejected",
                        5: "Verified",
                        6: "Verifier Rejected",
                        7: "Cancelled",
                      },
                    },
                    { title: "Name", field: "REASON_BY_NAME" },
                    {
                      title: "Reason",
                      field: "REASON",
                    },
                    {
                      title: "Date and Time",
                      field: "REASON_AT",
                      type: "datetime",
                      render: (rowData) =>
                        Moment(rowData.REASON_AT).format(
                          "DD-MMM-YYYY HH:mm:ss"
                        ),
                      defaultSort: "desc",
                    },
                  ]}
                  data={ReasonLog}
                  options={{
                    search: false,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} xs={12} className={classes.panelRoot}>
            {isAllowed(authorizePR.data, [
              "can_submit_budget_adjustment_requisition",
            ]) && (
              <Button
                color="primary"
                onClick={() => {
                  if (values.STATUS !== 0) {
                    Swal.fire({
                      title: "Submit your reason for submit",
                      input: "textarea",
                      inputAttributes: {
                        autocapitalize: "off",
                      },
                      showCancelButton: true,
                      confirmButtonText: "Submit",
                      showLoaderOnConfirm: true,
                      inputValidator: (value) => {
                        return new Promise((resolve) => {
                          if (value) {
                            resolve();
                          } else {
                            resolve("Please fill to reason for submit !");
                          }
                        });
                      },
                      allowOutsideClick: () => !Swal.isLoading(),
                    }).then((result) => {
                      if (result.isConfirmed) {
                        setFieldValue("STATUS", 2);
                        setFieldValue("REASON", result.value);
                        submitForm();
                      }
                    });
                  } else {
                    submitForm();
                  }
                }}
                disabled={Boolean(values.STATUS !== 0)}
                variant="contained"
                style={{
                  background: blue[600],
                }}
              >
                Submit
              </Button>
            )}
            {isAllowed(authorizePR.data, [
              "can_verify_budget_adjustment_requisition",
            ]) && (
              <Button
                color="primary"
                disabled={Boolean(values.STATUS !== 3)}
                onClick={(e) => {
                  e.preventDefault();

                  setFieldValue("STATUS", 5);
                  setFieldValue("REASON", "Verified");
                  setFieldValue("VERIFIED_BY_ID", perid);
                  setFieldValue("VERIFIED_BY_NAME", fullname);
                  setFieldValue(
                    "VERIFIED_AT",
                    Moment().format("YYYY-MM-DD HH:mm:ss")
                  );
                  submitForm();
                }}
                variant="contained"
              >
                Verify
              </Button>
            )}
            {isAllowed(authorizePR.data, [
              "can_verify_reject_budget_adjustment_requisition",
            ]) && (
              <Button
                color="secondary"
                style={{
                  background: red[600],
                }}
                disabled={Boolean(values.STATUS !== 3)}
                onClick={() => {
                  Swal.fire({
                    title: "Submit your reason for reject",
                    input: "textarea",
                    inputAttributes: {
                      autocapitalize: "off",
                    },
                    showCancelButton: true,
                    confirmButtonText: "Reject",
                    showLoaderOnConfirm: true,
                    inputValidator: (value) => {
                      return new Promise((resolve) => {
                        if (value) {
                          resolve();
                        } else {
                          resolve("Reason to reject is blank.");
                        }
                      });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setFieldValue("STATUS", 6);
                      setFieldValue("REASON", result.value);
                      setFieldValue("VERIFIED_BY_ID", perid);
                      setFieldValue("VERIFIED_BY_NAME", fullname);
                      setFieldValue(
                        "VERIFIED_AT",
                        Moment().format("YYYY-MM-DD HH:mm:ss")
                      );
                      submitForm();
                    }
                  });
                }}
                variant="contained"
              >
                {/* Verifier Rejected */}
                Reject
              </Button>
            )}
            {isAllowed(authorizePR.data, [
              "can_review_budget_adjustment_requisition",
            ]) && (
              <Button
                color="primary"
                onClick={(e) => {
                  e.preventDefault();

                  setFieldValue("STATUS", 3);
                  setFieldValue("REASON", "Reviewed");
                  setFieldValue("REVIEWED_BY_ID", perid);
                  setFieldValue("REVIEWED_BY_NAME", fullname);
                  setFieldValue(
                    "REVIEWED_AT",
                    Moment().format("YYYY-MM-DD HH:mm:ss")
                  );

                  submitForm();
                }}
                disabled={Boolean(
                  values.STATUS === 0 ||
                    values.STATUS === 3 ||
                    values.STATUS === 4 ||
                    values.STATUS === 5 ||
                    values.STATUS === 6 ||
                    values.STATUS === 7
                )}
                variant="contained"
              >
                Review
              </Button>
            )}
            {isAllowed(authorizePR.data, [
              "can_review_reject_budget_adjustment_requisition",
            ]) && (
              <Button
                color="secondary"
                style={{
                  background: red[600],
                }}
                disabled={Boolean(
                  values.STATUS === 0 ||
                    values.STATUS === 3 ||
                    values.STATUS === 4 ||
                    values.STATUS === 5 ||
                    values.STATUS === 6 ||
                    values.STATUS === 7
                )}
                onClick={() => {
                  Swal.fire({
                    title: "Submit your reason for reject",
                    input: "textarea",
                    inputAttributes: {
                      autocapitalize: "off",
                    },
                    showCancelButton: true,
                    confirmButtonText: "Reject",
                    showLoaderOnConfirm: true,
                    inputValidator: (value) => {
                      return new Promise((resolve) => {
                        if (value) {
                          resolve();
                        } else {
                          resolve("Reason to reject is blank.");
                        }
                      });
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                  }).then((result) => {
                    if (result.isConfirmed) {
                      setFieldValue("STATUS", 4);
                      setFieldValue("REASON", result.value);
                      setFieldValue("REVIEWED_BY_ID", perid);
                      setFieldValue("REVIEWED_BY_NAME", fullname);
                      setFieldValue(
                        "REVIEWED_AT",
                        Moment().format("YYYY-MM-DD HH:mm:ss")
                      );
                      submitForm();
                    }
                  });
                }}
                variant="contained"
              >
                {/* Reviewer Rejected */}
                Reject
              </Button>
            )}
            <Button
              variant="contained"
              onClick={(e) => {
                e.preventDefault();
                history.goBack();
              }}
            >
              Back
            </Button>
          </Grid>
          <Grid item lg={12} md={12} xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={4} md={12} xs={12}>
                <Card>
                  <CardHeader title="Prepared By BU" />
                  <Divider />
                  <CardContent>
                    <Typography variant="body2" component="p">
                      {values.REQUESTED_BY_NAME}
                    </Typography>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    {Moment(values.REQUESTED_AT).format("DD-MMM-YYYY")}
                  </CardActions>
                </Card>
              </Grid>
              <Grid item lg={4} md={12} xs={12}>
                <Card>
                  <CardHeader title="Reviewed By BU" />
                  <Divider />
                  <CardContent>
                    <Typography variant="body2" component="p">
                      {values.REVIEWED_BY_NAME
                        ? values.REVIEWED_BY_NAME
                        : "N/A"}
                    </Typography>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    {values.REVIEWED_AT
                      ? Moment(values.REVIEWED_AT).format("DD-MMM-YYYY")
                      : "N/A"}
                  </CardActions>
                </Card>
              </Grid>
              <Grid item lg={4} md={12} xs={12}>
                <Card>
                  <CardHeader title="Verified By Finance" />
                  <Divider />
                  <CardContent>
                    <Typography variant="body2" component="p">
                      {values.VERIFIED_BY_NAME
                        ? values.VERIFIED_BY_NAME
                        : "N/A"}
                    </Typography>
                  </CardContent>
                  <Divider />
                  <CardActions>
                    {values.VERIFIED_AT
                      ? Moment(values.VERIFIED_AT).format("DD-MMM-YYYY")
                      : "N/A"}
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    />
  );
}
